import "./style.css";
import { Game } from "./game/Game.ts";

const canvas = document.getElementById("game") as HTMLCanvasElement | null;
const ui = document.getElementById("ui") as HTMLElement | null;

if (!canvas || !ui) {
  throw new Error("Missing #game canvas or #ui root");
}

// Prevent iOS rubber-band / pinch-zoom from fighting the game input.
document.addEventListener("gesturestart", (e) => e.preventDefault());
document.addEventListener("touchmove", (e) => e.preventDefault(), { passive: false });

new Game(canvas, ui);
